import {
    updateChangeOrderCORNumber,
    getChangeOrders,
    getChangeOrder,
    getEligibleWorkOrders,
    createChangeOrder,
    addWorkOrdersToChangeOrder,
    removeWorkOrderFromChangeOrder,
    voidChangeOrder,
    noChargeChangeOrder,
    completeChangeOrder,
    updateChangeOrderNotes,
    setWorkOrderCONumber,
    setWorkOrderCONumbersBatch,
    clearWorkOrderCONumber
} from "../api/changeOrders";

const grabChangeOrders = async (status?: number, search?: string): Promise<any> => {
    try {
        return await getChangeOrders(status, search);
    } catch (err) {
        console.error("Error in grabChangeOrders", err);
        throw err;
    }
};

const grabChangeOrder = async (changeOrderID: number): Promise<any> => {
    try {
        const apiResults = await getChangeOrder(changeOrderID);
        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }
        return apiResults;
    } catch (err) {
        console.error("Error in grabChangeOrder", err);
        throw err;
    }
};

const grabEligibleWorkOrders = async (jobNumber: string, keyword?: string): Promise<any> => {
    try {
        return await getEligibleWorkOrders(jobNumber, keyword);
    } catch (err) {
        console.error("Error in grabEligibleWorkOrders", err);
        throw err;
    }
};

const createChangeOrderRequest = async (payload: { jobNumber: string; workOrderIDs: number[]; notes?: string }): Promise<any> => {
    try {
        return await createChangeOrder(payload);
    } catch (err) {
        console.error("Error in createChangeOrderRequest", err);
        throw err;
    }
};

const addWorkOrdersRequest = async (changeOrderID: number, workOrderIDs: number[]): Promise<any> => {
    try {
        return await addWorkOrdersToChangeOrder(changeOrderID, workOrderIDs);
    } catch (err) {
        console.error("Error in addWorkOrdersRequest", err);
        throw err;
    }
};

const removeWorkOrderRequest = async (changeOrderID: number, workOrderID: number): Promise<any> => {
    try {
        return await removeWorkOrderFromChangeOrder(changeOrderID, workOrderID);
    } catch (err) {
        console.error("Error in removeWorkOrderRequest", err);
        throw err;
    }
};

const voidChangeOrderRequest = async (changeOrderID: number, reason: string): Promise<any> => {
    try {
        return await voidChangeOrder(changeOrderID, reason);
    } catch (err) {
        console.error("Error in voidChangeOrderRequest", err);
        throw err;
    }
};

const noChargeChangeOrderRequest = async (changeOrderID: number, reason: string): Promise<any> => {
    try {
        return await noChargeChangeOrder(changeOrderID, reason);
    } catch (err) {
        console.error("Error in noChargeChangeOrderRequest", err);
        throw err;
    }
};

const completeChangeOrderRequest = async (changeOrderID: number): Promise<any> => {
    try {
        return await completeChangeOrder(changeOrderID);
    } catch (err) {
        console.error("Error in completeChangeOrderRequest", err);
        throw err;
    }
};

const updateNotesRequest = async (changeOrderID: number, notes: string): Promise<any> => {
    try {
        return await updateChangeOrderNotes(changeOrderID, notes);
    } catch (err) {
        console.error("Error in updateNotesRequest", err);
        throw err;
    }
};

const updateCORNumberRequest = async (changeOrderID: number, corNumber: number): Promise<any> => {
    try {
        return await updateChangeOrderCORNumber(changeOrderID, corNumber);
    } catch (err) {
        console.error("Error in updateCORNumberRequest", err);
        throw err;
    }
};

const setWorkOrderCONumberRequest = async (workOrderID: number, coNumber: string): Promise<any> => {
    try {
        return await setWorkOrderCONumber(workOrderID, coNumber);
    } catch (err) {
        console.error("Error in setWorkOrderCONumberRequest", err);
        throw err;
    }
};

const setWorkOrderCONumbersBatchRequest = async (changeOrderID: number, workOrderIDs: number[], coNumber: string): Promise<any> => {
    try {
        return await setWorkOrderCONumbersBatch(changeOrderID, workOrderIDs, coNumber);
    } catch (err) {
        console.error("Error in setWorkOrderCONumbersBatchRequest", err);
        throw err;
    }
};

const clearWorkOrderCONumberRequest = async (workOrderID: number): Promise<any> => {
    try {
        return await clearWorkOrderCONumber(workOrderID);
    } catch (err) {
        console.error("Error in clearWorkOrderCONumberRequest", err);
        throw err;
    }
};

export {
    grabChangeOrders,
    grabChangeOrder,
    grabEligibleWorkOrders,
    createChangeOrderRequest,
    addWorkOrdersRequest,
    removeWorkOrderRequest,
    voidChangeOrderRequest,
    noChargeChangeOrderRequest,
    completeChangeOrderRequest,
    updateNotesRequest,
    setWorkOrderCONumberRequest,
    setWorkOrderCONumbersBatchRequest,
    clearWorkOrderCONumberRequest,
    updateCORNumberRequest
};
